import {
  APPROVALS,
  MY_REQUESTS,
  PENDING_APPROVAL_DETAIL,
  PENDING_APPROVALS,
} from '@constants/internal-route.constant';
import { ROUTE_CODES } from '@constants/route-codes.constant';
import { IAppRoutes } from '@interface/common.interface';
import { lazy } from 'react';

export const ApprovalsRoutes: IAppRoutes = {
  link: APPROVALS,
  routeCode: ROUTE_CODES.APPROVALS,
  childrens: [
    {
      link: MY_REQUESTS,
      routeCode: ROUTE_CODES.MY_REQUESTS,
      element: lazy(() => import('@modules/approvals/MyRequests')),
    },
    {
      link: PENDING_APPROVALS,
      routeCode: ROUTE_CODES.PENDING_APPROVALS,
      element: lazy(() => import('@modules/approvals/PendingApprovals')),
    },
    {
      // The decision page. Same routeCode as the list it is opened from: PrivateRoutes treats a
      // MISSING routeCode as "always allow", so leaving it off would make this the one unguarded
      // screen in the group.
      link: PENDING_APPROVAL_DETAIL,
      routeCode: ROUTE_CODES.PENDING_APPROVALS,
      element: lazy(() => import('@modules/approvals/PendingApprovals/Detail')),
    },
  ],
};
